module.exports = __webpack_public_path__ + "assets/img/D3-Security-Landing-Page-+-Website-w540.11aba8ba.webp";